// Disable Missing "key" prop rule for Icons as they are added dynamically

/* eslint react/jsx-key: 0 */
import React from "react";
import { createSvgIconComponent } from "../utils";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var IconCVV = createSvgIconComponent({
  children: [___EmotionJSX("rect", {
    y: "1",
    width: "30",
    height: "19",
    rx: "3",
    fill: "#D9D9D9"
  }), ___EmotionJSX("rect", {
    y: "5",
    width: "30",
    height: "5",
    fill: "#B3B3B8"
  }), ___EmotionJSX("rect", {
    x: "3",
    y: "12",
    width: "24",
    height: "4",
    fill: "white"
  }), ___EmotionJSX("circle", {
    cx: "25",
    cy: "7",
    r: "7",
    fill: "#6D6E78"
  }), ___EmotionJSX("path", {
    d: "M21.988 9.258H22.597V10H20.301V9.258H21.099V6.556H20.322V5.814H21.099V5.135H21.988V9.258ZM25.0851 7.102C25.9391 7.13 26.5621 7.732 26.5621 8.558C26.5621 9.426 25.8201 10.084 24.7631 10.084C23.8321 10.084 23.1251 9.629 22.9291 8.971L23.7481 8.649C23.8671 9.048 24.2381 9.321 24.7421 9.321C25.2881 9.321 25.6381 8.971 25.6381 8.495C25.6381 7.998 25.2461 7.697 24.7771 7.697H24.0351V7.102L25.3511 5.842H23.1671V5.135H26.3521V5.835L25.0851 7.102ZM28.7468 6.934C29.8388 6.934 30.5528 7.55 30.5528 8.502C30.5528 9.433 29.8598 10.084 28.7258 10.084C27.8578 10.084 27.2278 9.692 26.9758 8.95L27.7878 8.621C27.9068 9.076 28.2848 9.328 28.7398 9.328C29.2858 9.328 29.6428 8.971 29.6428 8.488C29.6428 8.005 29.2858 7.634 28.7188 7.634H27.4238L27.5568 5.135H30.2308V5.835H28.3198L28.2568 6.934H28.7468Z",
    fill: "white"
  })],
  viewBox: "0 0 32 20"
});